import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

// What the control plane runs with (GET /api/config): feature flags and, on demo deployments only,
// the demo accounts the login page offers. One query, read whole or as whether it has answered yet.
const CONFIG = {
  queryKey: ["config"],
  queryFn: async () => (await api.get("/config")).data,
  staleTime: Infinity,
};

const useConfigQuery = () => useQuery(CONFIG);

export function useConfig() {
  return useConfigQuery().data || {};
}

// Feature flags, e.g. { github_remotes: true }.
export function useFlags() {
  return useConfig().flags || {};
}

// Whether the config has been asked for yet (answered or failed): before that every flag reads as off, so a page
// behind a flag waits for it rather than sending someone away.
export function useConfigLoaded() {
  return useConfigQuery().isFetched;
}
